import { Header } from '../../components/Header';
import { ComparativeSetTable } from './ComparativeSetTable';
import { Button, Box, Typography } from '@mui/material';

const ComparativeSets = () => {

    const CreateComparativeSetButton = () =>
        <Button
            sx={{ marginLeft: '20px' }}
            variant="contained"
            href={"create-comparative-set"}
        >
            Create Comparative Set
        </Button>

    return (
        <div>
            <Box sx={{ display: 'flex', justifyContent: 'space-between', marginBottom: '20px' }}>
                <Box>
                    <Typography variant="h6">Comparative Sets</Typography>
                </Box>
                <Box>
                    <CreateComparativeSetButton />
                </Box>
            </Box>
            <div style={{ height: '750px', width: '100%', marginBottom: 16 }}>
                <ComparativeSetTable />
            </div>
        </div>
    )
}

export default ComparativeSets;